import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, merge, timer } from 'rxjs';

@Injectable()
export class SwUpdateService {
    readonly REFRESH_TIMER: number = 3.6e+6;

    constructor(private updates: SwUpdate,
                private appRef: ApplicationRef,
                private router: Router) {
    }

    public checkForUpdates() {
        if (this.appRef.isStable && environment.production) {
            const refreshTimer$ = new BehaviorSubject(this.REFRESH_TIMER);

            refreshTimer$.pipe(
                distinctUntilChanged(),
                switchMap(refreshTimer =>
                    merge(
                        timer(0, refreshTimer),
                        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
                    )
                )
            ).subscribe({
                next: () => {
                    refreshTimer$.next(this.REFRESH_TIMER);
                    this.updates.checkForUpdate();
                }
            });
        }


        this.updates.available.subscribe(event => {
            this.promptUser();
        });
    }

    private promptUser() {
        this.updates.activateUpdate().then(() => {
            console.log('New version found and installed by ngsw');
            return document.location.reload();
        });
    }
}
